function calculateTimeLeft(timestamp: number) {
  const difference = Math.max(0, timestamp - new Date().getTime());

  const days    = Math.floor(difference / (1e3 * 60 * 60 * 24));
  const hours   = Math.floor((difference / (1e3 * 60 * 60)) % 24);
  const minutes = Math.floor((difference / (1e3 * 60)) % 60);

  return `${days}д : ${hours}ч : ${minutes}мин`;
}

export default calculateTimeLeft;